import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Currency from './currency';

export function AutoCalculatedFields({ deal }) {
  const isValidDealType = deal.dealType === 'sale' || deal.dealType === 'buyer_rep';
  if (!(isValidDealType && deal.transactionValue)) return null;

  return (
    <React.Fragment>
      {!!deal.numberOfUnits && (
        <Currency
          label="Price / Unit"
          name="numberOfUnits"
          value={deal.transactionValue / deal.numberOfUnits}
        />
      )}
      {!!deal.buildingSize && (
        <Currency
          label="Price / SF"
          name="buildingSize"
          value={deal.transactionValue / deal.buildingSize}
        />
      )}
      {!!deal.lotSize && (
        <Currency
          label={`Price / ${deal.lotSizeUnits === 'sf' ? 'SF' : 'Acre'}`}
          name="lotSize"
          value={deal.transactionValue / deal.lotSize}
        />
      )}
    </React.Fragment>
  );
}

AutoCalculatedFields.propTypes = {
  deal: PropTypes.shape({
    buildingSize: PropTypes.number,
    dealType: PropTypes.string.isRequired,
    lotSize: PropTypes.number,
    numberOfUnits: PropTypes.number,
    transactionValue: PropTypes.number,
  }).isRequired
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(AutoCalculatedFields);
